<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center">
        <div class="block relative bg-green-200 border-circle mr-2 xl:mr-2 height-3 width-3 p-3 xl:p-4">
            <span class="absolute text-xl text-0 left-0 font-medium top-0 ml-2 mt-2 xl:ml-3 xl:mt-3">2</span>
        </div>
        <span class="flex flex-1 text-700 font-medium xl:text-xl">
            {{ content[lang_].from }}
        </span>
    </div>
    <div class="w-full flex flex-column xl:flex-row relative gap-2">
        <div class="w-full flex flex-column max-w-30rem relative
            surface-0 xl:surface-100 lg:surface-100 md:surface-100
            border-round-2xl 
            p-3 xl:p-4">
            <span v-if="phone_number" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].phone_number }}:
            </span>
            <span v-if="phone_number" class="flex text-xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ phone_number }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(phone_number)"></span>
            </span>
            <span v-if="account_number" class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].account_number }}:
            </span>
            <span v-if="account_number" class="flex text-xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                <span>{{ account_number }}</span>
                <span class="pi pi-copy ml-3 text-500 text-xl cursor-pointer" @click="copy(account_number)"></span>
            </span>
            <span class="flex text-sm xl:text-lg text-600 mb-2 xl:mb-3">
                {{ content[lang_].name }}:
            </span>
            <span class="flex text-sm xl:text-lg font-medium text-900 mb-3 xl:mb-4">
                {{ fullname }}
            </span>
            <div class="flex flex-column bg-yellow-400 border-round-xl p-3">
                <span class="flex text-lg xl:text-lg text-yellow-900 font-medium line-height-2 mb-2 xl:mb-3">
                    {{ content[lang_].sbp_alert }}: {{ bank_title }}!
                </span>
                <div v-if="bank_image" class="w-full flex align-items-center justify-content-center">
                    <div class="relative flex surface-0 mt-3 border-circle align-items-center justify-content-center text-center" style="width:100px;height:100px">
                        <span class="w-full text-center h-3 w-3 p-3 xl:p-4">
                            <img :src="bank_image" class="w-full absolute left-0 top-0 p-2">
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex flex-column max-w-30rem relative py-1 xl:py-0 xl:px-8">
            <InlineMessage severity="success" class="border-round-2xl line-height-2 text-xs xl:text-md border-none" icon="pi pi-shield">
                <span class="line-height-2 text-xs xl:text-md lg:text-sm">{{ content[lang_].message }}</span>
            </InlineMessage>
        </div>
    </div>
</template>

<script>
import Helper from '@/assets/js/Helper'
export default {
    props: [
        'phone_number',
        'account_number',
        'fullname',
        'bank_code',
        'bank_image',
        'bank_title'
    ],
	data(){
		return{
			content: {
				en: {
					from: "To make a payment, make a transfer via SBP to the phone number",
                    to: "to the card ",
                    copied: "Copied",
                    phone_number: 'SBP phone number',
                    account_number: 'Account number',
                    name: 'Recipient name',
                    bank: 'Recipient bank',
                    message: 'Your funds are securely protected by the PayWave secure transaction system.',
                    sbp_alert: 'Attention! Transfer via FPS only to the bank'
				} ,
				ru: {
                    from: "В качестве оплаты совершите перевод по СБП по номеру телефона ",
                    to: "на карту ",
                    copied: "Скопировано",
                    phone_number: 'Номер телефона СБП',
                    account_number: 'Номер счета',
                    name: 'Имя получателя',
                    bank: 'Банк получателя',
                    message: 'Ваши средства надежно защищены системой безопасных сделок PayWave.',
                    sbp_alert: 'Внимание! Переводите по СБП только на банк'
				},
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
	},
	beforeCreate() {
        this.helper = new Helper()    
	}
}
</script>